import {memo, useMemo} from "react";
import {CartItemStyle} from "../cart.style";
import {IoIosCloseCircleOutline} from "react-icons/io";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";
import {IoLocationOutline} from "react-icons/io5";
import {CustomHelper} from "../../../../../../../helpers/custom-helper";
import CounterInput from "./counterInput";
import CartCheckbox from "./cartCheckbox";

export const CartItem = memo(({item, onToggle, onClick, onQuantityChange, onRemove}) => {
    const daysRemaining = useMemo(() => {
        if (!item.join_period_end_date) return 0;
        const endDate = new Date(item.join_period_end_date);
        const today = new Date();
        const diffTime = endDate - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }, [item.join_period_end_date]);

    return (<CartItemStyle
        onClick={() => onClick?.(item)}
        className={"tw-cursor-pointer d-flex mb-md-2 mb-2 align-items-center"}>
        <div className="first flex items-start">
            <CartCheckbox checked={item.selected} onChange={() => onToggle(item.split_buy_id)}/>
        </div>
        <div className={"d-flex gap-2 position-relative align-items-center"}>
            <IoIosCloseCircleOutline onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onRemove(item.cart_item_id)
            }}
                                     className={"position-absolute tw-top-0.5 tw-cursor-pointer tw-right-1"}/>
            <div className={"card-img flex-shrink-0"}>
                <img width={60} height={60} src={item.image} alt={item.title}/>
            </div>
            <CardBody>
                <div className={"first tw-space-y-1.5"}>
                    <CardTitle className={"tw-line-clamp-1 text-capitalize"}>{item.title}</CardTitle>
                    <CardText
                        className={"card-location card-location text-capitalize flex-nowrap d-flex align-items-center"}><IoLocationOutline/>{item.location}
                    </CardText>
                    <CardText
                        className={"card-delivery-date"}>Delivery: {item.delivery_date ? CustomHelper.formatDateToReadable(new Date(item.delivery_date)) : "Not specified"}</CardText>
                </div>
                <div className={"amount"}>
                    <CardText className={"d-flex align-items-baseline"}>
                        <span>₦{(item.price * item.quantity)?.toLocaleString()}</span>
                        <span style={{color: "#85CD83"}}> | </span>
                        <small>{item.quantity} Slot{item.quantity > 1 ? 's' : ''}</small>
                    </CardText>
                </div>
            </CardBody>
            <div className={"quantity d-flex tw-flex-col"}>
                <div className="md:tw-space-y-1.5 tw-space-y-1">
                    <Badge className="d-flex align-items-center" style={{marginLeft: "auto", alignSelf: "end"}}
                           pill>
                        <Badge
                            pill>{item.number_of_buy_ins_attained}/{item?.total_slots}</Badge> Slot{item.total_slots > 1 ? 's' : ''}
                    </Badge>
                    <CardText>
                        <b>{daysRemaining > 0 ? daysRemaining : 0} day{daysRemaining > 1 ? "s" : ""}</b> remaining
                    </CardText>
                </div>
                <CounterInput
                    value={item.quantity}
                    max={item.available_slots}
                    onChange={(val) => onQuantityChange(item.cart_item_id, val)}
                />
            </div>
        </div>
    </CartItemStyle>)
})
